import { bigEndianCrc32 } from "../utils/crc";

export default {
  isValidAddress(address) {
    if (address.length !== 64) {
      return false;
    }

    const bytes = Buffer.from(address, "hex");
    const checksum = bytes.slice(0, 4);
    const expectedCheckum = Buffer.from(bigEndianCrc32(bytes.slice(4)));
    if (!expectedCheckum.equals(checksum)) {
      return false;
    }

    return true;
  },
};
